jQuery(document).ready(function($) {

$video_modal = $('#video_modal');

  var modal = document.getElementById('video_modal');

  // get base URL (strip any existing query string)
  var rawSrc = $("#video_modal iframe").attr("src") || "";
  var videoBase = rawSrc.split('?')[0]; // safety: removes existing params like mute=1

  $('#video_icon').on('click', function(e) {
    e.preventDefault();

    $video_modal.css('opacity', '1');
    $video_modal.css('visibility', 'visible');

    // build params — use mute=0 to unmute, controls=1 so user can see volume UI
    var params = "start=7&autoplay=1&mute=0&controls=1&showinfo=0&iv_load_policy=3&rel=0&modestbranding=1";
    $('#video_player').attr("src", videoBase + "?" + params);

    disableScroll();
  });
    $('#close_icon').on('click',function(e) {
      $("#video_modal iframe").attr("src", null);
      $video_modal.css('opacity', '0');
      $video_modal.css('visibility', 'hidden');
      enableScroll();
      e.preventDefault();
    });

    window.onclick = function(event) {
      if (event.target == modal) {
        $("#video_modal iframe").attr("src", null);
        $video_modal.css('opacity', '0');
        $video_modal.css('visibility', 'hidden');
        enableScroll();
      }
    }
  });

  function disableScroll() { 
    // Get the current page scroll position 
    scrollTop = window.pageYOffset || document.documentElement.scrollTop; 
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, 

      // if any scroll is attempted, set this to the previous value 
      window.onscroll = function() { 
      window.scrollTo(scrollLeft, scrollTop); 
    }; 
  } 

  function enableScroll() { 
    window.onscroll = function() {}; 
  } 
